import dynamic from 'next/dynamic';
import React from 'react';
import { ReactPlayerProps } from 'react-player';
import { useMobileApp } from '../../../../../hooks/useMobileApp';

const ReactPlayer = dynamic(() => import('react-player'));

/**
 * The react player cannot handle youtube live urls atm - therefore we replace this
 * with an iframe
 * @param url
 * @returns
 */
const testYouTubeLive = (url: string) => /youtube.com\/embed\/live_stream\?channel=/.test(url);

const WelcomeVideoPlayer = (reactProps: ReactPlayerProps) => {
  const { isAppView } = useMobileApp();
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full">
        {typeof reactProps?.url === 'string' && testYouTubeLive(reactProps?.url) ? (
          <iframe width="100%" height="100%" src={reactProps?.url} id={reactProps.id} />
        ) : (
          <ReactPlayer playsinline={isAppView()} {...reactProps} width="100%" height="100%" className="overflow-hidden h-full video-player-inner" controls />
        )}
      </div>
    </>
  );
};

export default WelcomeVideoPlayer;
